module.exports = __webpack_public_path__ + "static/media/Gardevoir_gaussian2.10478370.png";